import Typography from "@material-ui/core/esm/Typography";
import React from 'react';
import useStyles from './TextStyles';
export default function LargeHeader({
  children,
  align
}) {
  const {
    title
  } = useStyles();
  return /*#__PURE__*/React.createElement(Typography, {
    align: align,
    variant: "h1",
    className: title
  }, children);
}
LargeHeader.defaultProps = {
  align: 'left',
  to: ''
};